
import { LIBRARY_CONFIGS } from "@/constants/libraries";
import { Options, Vue } from "vue-class-component";

interface Library {
  title: string;
  description: string;
  brandImage: string;
  backgroundColor: string;
  link: string;
}

@Options({
  inject: ["mq", "eventConfig"]
})
export default class Libraries extends Vue {
  get libraries(): Library[] {
    return Object.entries(LIBRARY_CONFIGS).map(([eventName, config]) => ({
      ...config,
      link: `/${eventName}`
    }));
  }
}
